import logo from './logo.svg';
import Story from './Story';
import Faq from './Faq';
import Home from './Home';
import Invest from './Invest';
import Career from './Career';
import Blog from './Blog';
import {Route, Switch} from "react-router-dom"
import MuiDrawer from './MuiDrawer';
import Aero from './Aero';
import Project from './Project';
import Contact from './Contact';
import './App.css';
import Pop from './Pop';


export default function App() {
  return (
        
        <>
          {/* <MuiDrawer/> */}
          {/* <Pop/> */}
          
          <Switch>

            <Route exact from='/' render ={props => <Home {...props}/>}/>
            <Route exact path='/story' render={props => <Story {...props}/>} />
            <Route  exact path='/faq' target={"_blank"} render={props => <Faq {...props}/>} />
            <Route  exact path='/invest'  render={props => <Invest {...props}/>} />
            <Route  exact path='/career'  render={props => <Career {...props}/>} />
            <Route  exact path='/blog'  render={props => <Blog {...props}/>} />
            <Route  exact path='/blog/aerospace'  render={props => <Aero {...props}/>} />
            <Route  exact path='/blog/invest-project'  render={props => <Project {...props}/>} />
            <Route  exact path='/contact'  render={props => <Contact {...props}/>} />
            
            
          </Switch>
        </>
        
      
  );
}


